import VideoGallery from "./ShowVideos";
function VideosPage() {
  return (
    <div className="min-h-screen bg-gray-200 py-10 px-4 md:px-8">
      <div className="max-w-7xl mx-auto">
        <h1 className="mb-8 text-3xl md:text-4xl font-bold text-gray-800 text-center">
          Video Gallery
        </h1>
        <VideoGallery />
      </div>
    </div>
  );
}


export default VideosPage